
import * as PIXI from 'pixi.js';
import store from '__common/store';

export const rubberBandModel = (points: pixelPoint[]) => {
  const settings = store.getState().settings;
  const rubberBand: PIXI.Graphics = new PIXI.Graphics();
  rubberBand.id = 'rubberBand';
  rubberBand.lineStyle(1, settings.rubberBandColor);

  // Filter out undefined or invalid points
  const validPoints = points.filter(point => point && point.x !== undefined && point.y !== undefined && !isNaN(point.x) && !isNaN(point.y));
  
  if (validPoints.length < 3) {
    console.warn('Insufficient valid points for rubberBand polygon');
    return rubberBand;
  }

  const preparedPoints = validPoints.reduce((acc, point) => {
    acc.push(point.x);
    acc.push(point.y);
    return acc;
  }, []);
  
  // Close the polygon by adding the first point
  preparedPoints.push(validPoints[0].x, validPoints[0].y);
  
  try {
    rubberBand.drawPolygon(preparedPoints);
    rubberBand.endFill();
  } catch (error) {
    console.error('Error drawing rubberBand polygon:', error);
  }
  
  rubberBand.zIndex = 9999;
  return rubberBand;
};

export default rubberBandModel;
